<template lang="html">
  <div class="access-reset-password-error mt-8">
    <p class="body1 blue--text text--darken-1 text-center mb-6">
      {{ title }}
    </p>

    <p class="text-center">{{ description }}</p>

    <Button
      block
      data-testid="expiredLink-button-sendNewLink"
      class="mt-7"
      color="primary"
      :text="$t('authManagePeople.send_new_link')"
      @click="$emit('onClickGoTo')"
    />
  </div>
</template>

<script>
import Button from '@/components/UI/Button'

export default {
  components: {
    Button,
  },

  computed: {
    title() {
      return this.$t('authManagePeople.expired_link')
    },

    description() {
      return this.$t('authManagePeople.expired_link_description')
    },
  },
}
</script>
